import { Pipe, PipeTransform } from '@angular/core';
import memo from 'memo-decorator';

@Pipe({
    name: 'cnpj',
    standalone: false
})
export class CNPJPipe implements PipeTransform {
  @memo()
  transform(cnpjValue: any) {
    if (!cnpjValue) {
      return '';
    }

    const cnpj = cnpjValue.replace(/[.\-/\s]/g, '');
    return cnpj.replace(/^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
}
